import Phaser from 'phaser';
import Forces from '../common/Forces';
import ABCyaPhaser from '@abcya/abcya_phaser';

export default class CrumbSprite extends Phaser.GameObjects.Image {
  /**
   * 
   * @param {Phaser.Scene} scene 
   */
  constructor(scene,sx, sy, dx, dy) {
    super(scene, 0,0,ABCyaPhaser.Images.DEFAULT_ATLAS);

    this.startX = sx;
    this.startY = sy;
    this.destX = dx;
    this.destY = dy;

    this.fade = true;

    this.mass = 1.0;
    this.gravity = 0;
    this.k = 0.0;

    this.pos = new Phaser.Math.Vector2();
    this.vel = new Phaser.Math.Vector2();
    this.lifetime = 2;
    this.age = 0;
    this.halflife = 0;

    this.gravityForce = new Phaser.Math.Vector2();
    this.dragForce = new Phaser.Math.Vector2();
    this.totalForce = new Phaser.Math.Vector2();

    Forces.constantGravity(this.mass, this.gravity, this.gravityForce);
  }

  reset (pos,vel,lifetime, sn) {
    this.pos.x = pos.x;
    this.pos.y = pos.y;
    this.vel.x = vel.x;
    this.vel.y = vel.y;
    this.lifetime = lifetime;
    this.halflife = lifetime / 2;
    this.age = 0;
    this.alpha = 1;
    this.scale = 0.8;
    this.setFrame(sn);
    this.setOrigin(0.5);
    this.gravity = Phaser.Math.Between(0,850);
    Forces.constantGravity(this.mass, this.gravity, this.gravityForce);

    this.update();
  }

  update () {
    this.x = this.pos.x;
    this.y = this.pos.y;
  }

  move (dt) {
    this.pos.add({ x: this.vel.x * dt,y: this.vel.y * dt });
    this.angle += this.vel.x * dt;
  }

  calcForce () {
    if (this.k === 0) {
      this.dragForce.reset();
    }
    else {
      this.dragForce.set(this.vel.x, this.vel.y);
      Forces.linearDrag(this.k, this.vel, this.dragForce);
    }
    Forces.add([this.gravityForce, this.dragForce],this.totalForce);
  }

  updateAccel () {
    this.totalForce.multiply({ x: 1 / this.mass, y: 1 / this.mass });
  }

  updateVelocity (dt) {
    this.vel.add({ x: this.totalForce.x * dt, y: this.totalForce.y * dt });
  }

  tick (dt) {
    this.move(dt);
    this.calcForce();
    this.updateAccel();
    this.updateVelocity(dt);

    this.age += dt;
    this.angle += this.vel.x * dt;

    if (this.fade && this.age > this.halflife) {
      this.alpha -= 0.8 * dt;
    }
    return this.age < this.lifetime;
  }
}